export const getAuthUser = '/api/auth/me';
export const renewToken = '/api/auth/renew';
export const login = '/api/auth/login';
export const sendResetEmail = '/api/auth/forget';
export const resetPassword = '/api/auth/reset';